import React from "react";

const Sponsors = ({isActive, sponsors}) => {
	return (
		<section id="sponsors" className={`${isActive ? 'active' : ''}`}>
			<h2>Sponsors</h2>
			{
				Object.keys(sponsors).map(sponsorTier => {
					const tierSponsors = sponsors[sponsorTier];
					if (!tierSponsors.length) {
						return null;
					}

					return (
						<section key={sponsorTier} className={`sponsors-list ${sponsorTier}`}>
							<h2 className={`sponsor-tier ${sponsorTier}`}>{sponsorTier}</h2>
							<SponsorsList sponsors={tierSponsors} />
						</section>
					)
				})
			}
		</section>
	)
}

const SponsorsList = ({sponsors}) => {
	return (
		<div className={'sponsors'}>
			{
				sponsors.map((sponsor, idx) => {
					const sponsorPhotoStyle = {
						backgroundImage: `url("${sponsor.imageUrl}")`,
					}
					return (
						<article className="sponsor" key={`${sponsor.name}-${idx}`}>
							<a href={sponsor.url} title={sponsor.name} rel="noreferrer" target="_blank">
								<div style={sponsorPhotoStyle} />
							</a>
						</article>
					)
				})
			}
		</div>
	)
}

export default Sponsors;
